import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import Edit from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Access from '../../Utils/authorize';
import Axios from '../../REST/base';
import PageShell from '../../themes/components/PageShell';
import PageHeader from '../../themes/components/PageHeader';
import PageContent from '../../themes/components/PageContent';
import Action from '../../themes/components/Action';
import ResponsiveDataGrid from '../../themes/components/ResponsiveDataGrid';

function Asset() {
  const navigate = useNavigate();

  const ColorCell = (params) => {
    return (
      <input
        value={params.row.color}
        type="color"
        readOnly
        style={{
          height: '40px',
          width: '40px',
          border: 'none',
          background: 'none',
          cursor: 'pointer',
        }}
      />
    );
  };

  const columns = [
    { field: 'name', headerName: 'Asset Name', flex: 0.3, minVisible: 'xs' },
    { field: 'description', headerName: 'Description', flex: 0.3, minVisible: 'xs' },
    {
      field: 'color',
      headerName: 'Color',
      flex: 0.2,
      minVisible: 'md',
      renderCell: (params) => <ColorCell {...params} />
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 0.1,
      minVisible: 'md',
      valueGetter: (params) => params.row.status ? 'Enabled' : 'Disabled'
    },
    {
      headerName: 'Actions',
      flex: 0.2,
      field: '_id',
      minVisible: 'xs',
      renderCell: (params) => (
        <>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              navigate(`createAsset/${params?.id}`);
            }}
            title="Edit"
          >
            <Edit />
          </IconButton>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              // Toggle status here if needed
            }}
            title={params.row.status ? 'Disable' : 'Enable'}
          >
            {!params.row.status && <VisibilityIcon />}
            {params.row.status && <VisibilityOffIcon />}
          </IconButton>
        </>
      ),
    },
  ];

  const fetchAssets = useCallback(async (page, limit, filters, sort) => {
    const params = {
      page,
      limit
    }
    
    if (Object.keys(filters).length > 0) {
      params.filters = JSON.stringify(filters)
    }
    
    if (sort) {
      params.sort = JSON.stringify(sort)
    }

    const result = await Axios().get('Assets/GetAssets', { params })

    if (result.data?.data) {
      return {
        data: result.data.data,
        pagination: result.data.pagination
      };
    }

    if (Array.isArray(result.data)) {
      return {
        data: result.data,
        pagination: { total: result.data.length, page: 1, totalPages: 1 }
      };
    }

    return { data: [], pagination: { total: 0, page: 1, totalPages: 0 } };
  }, []);

  const handleRowClick = (row) => {
    navigate(`createAsset/${row._id}`);
  };

  return (
    <PageShell>
      <PageHeader
        title="Asset"
        back
        onBack={() => navigate(-1)}
        actions={
          Access.isInternal() ? (
            <Action
              primary
              icon={<AddIcon />}
              label="Create New Master Asset"
              onClick={() => navigate('createAsset')}
            />
          ) : null
        }
      />

      <PageContent fill>
        <ResponsiveDataGrid
          columns={columns}
          fetchData={fetchAssets}
          initialPageSize={10}
          pageSizeOptions={[10, 25, 50, 100]}
          getRowId={(i) => i?._id}
          onRowClick={handleRowClick}
        />
      </PageContent>
    </PageShell>
  );
}

export default Asset;
